<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="dropbox">
            <input class="input-file" type="file" @change="getFiles" />
            <p v-if="uploadList.length == 0" class="extra-margin"
              >Drag file to upload or click to browse</p
            >
            <div v-if="uploadList.length > 0" class="extra-margin">
              <p
                class="uploadList"
                v-for="(item, index) in items"
                :key="index"
                >{{ item.name }}</p
              >
            </div>
          </div>
          <v-row>
            <v-col sm="12"> </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="uploadDocument" :disabled="saving" color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import Document from '@classes/Document'
//templateTODO: import lookup components you plan to use
export default {
  components: {},
  data: () => ({
    dialog: false,
    valid: true,
    selectedDocument: new Document(),
    modalText: '',
    uploadList: [],
    items: [],
  }),
  created() {},
  computed: {
    ...get('document', ['saving']),
    billID() {
      if (this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }
    },
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('document', ['saveDocument']),
    async validate() {
      this.$refs.form.validate()
    },
    editDocument(entry) {
      this.selectedDocument = new Document(entry)
      this.modalText = 'Edit Document'
      this.dialog = !this.dialog
    },
    addDocument() {
      this.modalText = 'Insert Document'
      this.selectedDocument = new Document({ TrackedBillID: this.billID })
      this.dialog = !this.dialog
    },
    getFiles: function (event) {
      this.uploadList = []
      this.items = []
      for (let file in event.target.files) {
        this.uploadList.push(event.target.files[file])
      }
      for (let i = 0; i < this.uploadList.length - 2; i++) {
        if (this.uploadList[i].name) this.items.push(this.uploadList[i])
      }
    },
    uploadDocument() {
      this.validate().then(() => {
        if (this.valid) {
          var self = this
          for (let i = 0; i < this.uploadList.length - 2; i++) {
            let file = this.uploadList[i]
            let fileReader = new FileReader()
            if (fileReader && file) {
              fileReader.readAsDataURL(file)
              fileReader.onload = () => {
                let contents = fileReader.result.split(',')[1]
                let document = this.selectedDocument.removeRelated()
                document.DocumentFile.File = contents
                document.FileName = file.name
                document.MimeType = file.type
                this.saveDocument(document).then(
                  (res) => {
                    this.dialog = false
                    this.$emit('refresh')
                    this.selectedDocument = new Document({
                      TrackedBillID: this.billID,
                    })
                    this.uploadList = []
                    this.items = []
                    this.$refs.form.resetValidation()
                  },
                  (err) => {}
                )
              }
            }
          }
        }
      })
    },
    // saveDocumentDetails() {
    //   this.validate().then(() => {
    //     if (this.valid) {
    //       //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
    //       this.saveDocument(this.selectedDocument.removeRelated()).then(
    //         (res) => {
    //           this.$emit('refresh')
    //           this.selectedDocument = new Document()
    //           this.$refs.form.resetValidation()
    //         },
    //         (err) => {}
    //       )
    //       this.dialog = false
    //     }
    //   })
    // },
    cancelEntry() {
      this.dialog = false
      this.selectedDocument = new Document()
      this.uploadList = []
      this.items = []
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style scoped>
.dropbox {
  outline: 2px dashed rgb(190, 190, 190); /* the dash box */
  outline-offset: -10px;
  background: #fafafa;
  color: var(--v-accent-base);
  padding: 10px 10px;
  position: relative;
  cursor: pointer;
  height: 100px;
  margin-top: 10px;
}

.input-file {
  outline: 2px solid black;
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100px;
  position: absolute;
  cursor: pointer;
}
</style>
